import {searchPresets} from 'decentralized/presets/PresetsSearcher.js';
import {ZOBJECT} from 'constants/object-types.js';

export default superclass => class extends superclass {

    loadSubPatch(name) {
        return new Promise((resolve) => {
            searchPresets(
                undefined,
                "zobject.subpatch",
                [],
                0,
                undefined,
                false,
            )
                .then(x => {
                    let preset = x.find(y => y.title.includes(name));
                    
                    if (!preset) {
                        return;
                    }
                    
                    let zobject = this.createZObject(1,1,"subpatch", false);
                    zobject.loadPreset(preset);
                    zobject.isUI = true;
                    console.log('setting isUI =', zobject);
                    resolve(zobject);
                });
        });
    }
}
